
import {sendBaseLog, sendUbcLog} from '@/lib/utils/thunder';

export default {
    'news:pageShowLog'(foo, {getState}) {
        sendBaseLog({
            tid: 126,
            cst: 1,
            logInfo: 'landing',
            logExtra: {
                flow: 2,
                st: 'news',
                source: getState('common.isBjh'),
                login: +getState('common.isLogin'),
                appId: getState('article.itemData.infoBaiJiaHao.link'),
            },
        });
        sendBaseLog({
            tid: 10814,
            cst: 1,
            logInfo: 'show',
        });
    },
    'log:follow:show'(state) {
        sendUbcLog({
            ubcId: 14612,
            params: {
                page: 'news_landing_pc_follow',
                type: 'show',
                from: 'feed_news',
                value: state ? 'news_pc_follow' : 'news_pc_unfollow',
                source: 'media_detail_pc',
                appname: 'pc',
            },
        });
    },
    'log:follow:click'(state) {
        sendUbcLog({
            ubcId: 14612,
            params: {
                page: 'news_landing_pc_follow',
                type: 'click',
                from: 'feed_news',
                value: !state ? 'news_pc_follow_click' : 'news_pc_unfollow_click',
                source: 'media_detail_pc',
                appname: 'pc',
            },
        });
    },
    'backTop:showLog'(foo) {
        sendBaseLog({
            tid: 133,
            cst: 1,
            logInfo: 'back_to_top',
        });
    },
    'backTop:clkLog'(foo) {
        sendBaseLog({
            tid: 138,
            cst: 2,
            logInfo: 'back_to_top',
        });
    },
    'recentArticle:showLog'(foo) {
        sendBaseLog({
            tid: 135,
            cst: 1,
            logInfo: 'recent_article',
        });
    },
    'recentArticle:clkLog'(data) {
        sendBaseLog({
            tid: 147,
            cst: 2,
            logInfo: 'recent_article',
            logExtra: {
                pos: data && data.pos,
            },
        });
    },
    'relatedNews:showLog'(foo) {
        sendBaseLog({
            tid: 136,
            cst: 1,
            logInfo: 'related_news',
        });
    },
    'relatedNews:clkLog'(data) {
        sendBaseLog({
            tid: 148,
            cst: 2,
            logInfo: 'related_news',
            logExtra: {
                pos: data && data.pos,
            },
        });
    },
    'topBar:logoClkLog'(foo) {
        sendBaseLog({
            tid: 139,
            cst: 2,
            logInfo: 'head_logo',
        });
    },
    'topBar:menuClkLog'(data) {
        sendBaseLog({
            tid: 142,
            cst: 2,
            logInfo: 'head_menu',
            logExtra: {
                type: data && data.type,
            },
        });
    },
    'topBar:usrMenuShowLog'(data) {
        sendBaseLog({
            tid: 131,
            cst: 1,
            logInfo: 'usr_menu',
        });
    },
    'topBar:usrMenuClkLog'(data) {
        sendBaseLog({
            tid: 146,
            cst: 2,
            logInfo: 'usr_menu',
            logExtra: {
                type: data && data.type,
                pos: data && data.pos,
            },
        });
    },
    'video:showLog'(data) {
        sendBaseLog({
            tid: 950,
            cst: 1,
            logInfo: 'main_video',
            logExtra: {
                vid: data && data.vid,
            },
        });
    },
    'video:playLog'(data) {
        sendBaseLog({
            tid: 951,
            cst: 2,
            logInfo: 'main_video',
            logExtra: {
                vid: data && data.vid,
                state: 'starton',
            },
        });
    },
    'video:pauseLog'(data) {
        sendBaseLog({
            tid: 952,
            cst: 2,
            logInfo: 'main_video',
            logExtra: {
                vid: data && data.vid,
                state: 'pause',
            },
        });
    },
    'video:replayLog'(data) {
        sendBaseLog({
            tid: 953,
            cst: 2,
            logInfo: 'main_video',
            logExtra: {
                vid: data && data.vid,
                state: 'replay',
            },
        });
    },
    'video:endLog'(data) {
        const {vid, duration} = data || {};
        sendBaseLog({
            tid: 954,
            cst: 2,
            logInfo: 'main_video',
            logExtra: {
                vid,
                state: 'end',
                duration,
            },
        });
    },
    'audio:showLog'(data) {
        const {songid, fileDuration} = data;
        sendBaseLog({
            tid: 2118,
            cst: 2,
            logInfo: 'main_real_audio_show',
            logExtra: {
                songid,
                'file_duration': fileDuration,
            },
        });
    },
    'audio:playLog'(data) {
        const {songid, fileDuration} = data;
        sendBaseLog({
            tid: 2119,
            cst: 2,
            logInfo: 'main_real_audio_play',
            logExtra: {
                songid,
                'file_duration': fileDuration,
            },
        });
    },
    'audio:pauseLog'(data) {
        const {songid, fileDuration} = data;
        sendBaseLog({
            tid: 2120,
            cst: 2,
            logInfo: 'main_real_audio_pause',
            logExtra: {
                songid,
                'file_duration': fileDuration,
            },
        });
    },
    'readSrc:showLog'() {
        sendBaseLog({
            tid: 132,
            cst: 1,
            logInfo: 'readsrc',
        });
    },
    'readSrc:clkLog'() {
        sendBaseLog({
            tid: 137,
            cst: 2,
            logInfo: 'readsrc',
        });
    },
    'changan:showLog'() {
        sendBaseLog({
            tid: 11529,
            cst: 1,
            logInfo: 'changan_landingpc_show',
        });
    },
    'ttsLog:click'(value) {
        sendBaseLog({
            tid: 11548,
            cst: 2,
            logInfo: 'tts_click',
            logExtra: {
                type: 'tts_button_click',
                value,
            },
        });
    },
    'ttsLog:btnShow'() {
        sendBaseLog({
            tid: 11547,
            cst: 2,
            logInfo: 'tts_show',
            logExtra: {
                type: 'tts_button_show',
            },
        });
    },
    'guideAction:log'(data) {
        sendUbcLog({
            ubcId: 11182,
            params: {
                page: 'pc_landing',
                type: data.type,
            },
        });
    },
};
